import { Icon } from '@iconify/react';
import type { ReactNode } from 'react';

import type { CheckoutResponse } from '../api/checkout';
import { checkoutLineLabel } from '../utils/checkoutLines';

export interface OrderSummaryRailProps {
  checkout: CheckoutResponse;
  /** Optional content rendered above the "Order summary" heading (amount due, partial card). */
  children?: ReactNode;
}

export default function OrderSummaryRail({ checkout, children }: OrderSummaryRailProps) {
  const priceUsd = Number(checkout.priceUsdSnapshot);

  return (
    <aside className="ps-rail" style={{ display: 'flex', flexDirection: 'column' }}>
      {children}
      <div className="ps-kicker">Order summary</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginTop: 14 }}>
        {checkout.lineItems.map((line) => {
          const product = line.productSnapshot;
          return (
            <div key={line.id} style={{ display: 'flex', gap: 14 }}>
              {product.imageUrl ? (
                <img
                  src={product.imageUrl}
                  alt=""
                  style={{ width: 64, height: 64, borderRadius: 10, objectFit: 'cover' }}
                />
              ) : null}
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 15 }}>{checkoutLineLabel(line)}</div>
                {product.description ? (
                  <div style={{ fontSize: 13, color: '#6b7280', marginTop: 2 }}>
                    {String(product.description)}
                  </div>
                ) : null}
                <div style={{ fontSize: 13, marginTop: 4 }}>
                  ${Number(line.lineTotalUsdSnapshot).toFixed(2)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ borderTop: '1px solid #e5e7eb', marginTop: 14, paddingTop: 14 }}>
        <div className="ps-row">
          <span className="ps-muted" style={{ fontSize: 13 }}>Subtotal</span>
          <span style={{ fontSize: 13 }}>${priceUsd.toFixed(2)}</span>
        </div>
      </div>
      <div style={{ borderTop: '1px solid #e5e7eb', marginTop: 14, paddingTop: 14 }}>
        <div className="ps-row" style={{ marginBottom: 0 }}>
          <span style={{ fontSize: 15, fontWeight: 600 }}>Total</span>
          <span style={{ fontSize: 22, fontWeight: 700 }}>${priceUsd.toFixed(2)}</span>
        </div>
        <div style={{ textAlign: 'right', fontSize: 12, color: '#9ca3af', marginTop: 2 }}>USD</div>
      </div>
      <div className="ps-secure" style={{ marginTop: 'auto', paddingTop: 24 }}>
        <Icon icon="mdi:lock-outline" width={16} height={16} />
        Secured by crypto payment protocol
      </div>
    </aside>
  );
}
